<script>
import { defineComponent } from "vue";

export default defineComponent({
  setup(props, context) {
    return () => (
      <el-button class="table-button" {...context.attrs} text type="primary">
        {context.slots.default && context.slots.default()}
      </el-button>
    );
  },
});
</script>
<style lang="scss" scoped>
.table-button {
  margin: 2px 5px;
  padding: 0 !important;
  height: auto;
  &:active {
    background-color: #fff !important;
  }
}
.table-button + .table-button {
  margin-left: 5px;
}
</style>
